export default __webpack_public_path__ + "static/media/location-red.493e90b8.svg";